import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import type { NavLink } from "../../data";

interface ViewAllLinkProps {
  link: NavLink;
  // Desktop mega menu: wrap in NavigationMenuLink so Radix closes the menu
  // and handles focus. The mobile drawer passes `onClick` instead.
  isMenuLink?: boolean;
  onClick?: () => void;
  className?: string;
}

const linkClass =
  "flex-row items-center justify-between gap-2 rounded-xl px-3.5 py-2 text-[14.5px] font-bold text-primary hover:bg-paper hover:text-primary focus:bg-paper focus:text-primary";

// "View all products / solutions ->" at the foot of a menu panel (the
// preview's `.all-link`): bold red text with an arrow, paper on hover.
const ViewAllLink = ({ link, isMenuLink = false, onClick, className }: ViewAllLinkProps) => {
  const content = (
    <>
      {link.label}
      <ArrowRight className="size-4 text-current" aria-hidden="true" />
    </>
  );
  return isMenuLink ? (
    <NavigationMenuLink asChild className={cn(linkClass, className)}>
      <Link href={link.route}>{content}</Link>
    </NavigationMenuLink>
  ) : (
    <Link href={link.route} onClick={onClick} className={cn("flex", linkClass, className)}>
      {content}
    </Link>
  );
};

export default ViewAllLink;
